import type { SVGProps } from "react"

const IDFront = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
    <circle data-name="Ellipse 4692" cx={175} cy={175} r={175} fill="#fff" />
    <rect
      data-name="Rectangle 1501"
      width={242.626}
      height={161.751}
      rx={9.732}
      transform="translate(49.293 89.039)"
      fill="#fff"
    />
    <path
      data-name="Path 40215"
      d="M279.075 252.769H62.136a14.84 14.84 0 01-14.823-14.823V101.883A14.84 14.84 0 0162.136 87.06h216.939a14.84 14.84 0 0114.825 14.823v136.063a14.84 14.84 0 01-14.825 14.823zM62.136 91.019a10.875 10.875 0 00-10.863 10.864v136.063a10.875 10.875 0 0010.863 10.864h216.939a10.877 10.877 0 0010.865-10.864V101.883a10.877 10.877 0 00-10.865-10.864z"
      fill="#1d1d1b"
    />
    <rect
      data-name="Rectangle 1502"
      width={85.827}
      height={9.403}
      rx={4.701}
      transform="translate(169.331 148.024)"
      fill="#c6c6c5"
    />
    <rect
      data-name="Rectangle 1503"
      width={75.8}
      height={9.403}
      rx={4.701}
      transform="translate(71.362 104.21)"
      fill="currentColor"
    />
    <rect
      data-name="Rectangle 1504"
      width={75.8}
      height={9.403}
      rx={4.701}
      transform="translate(71.362 119.121)"
      fill="currentColor"
    />
    <rect
      data-name="Rectangle 1505"
      width={42.914}
      height={9.403}
      rx={4.701}
      transform="translate(229.75 111.937)"
      fill="#c6c6c5"
    />
    <path
      data-name="Path 40216"
      d="M139.771 207.693v11.17a5.872 5.872 0 01-5.872 5.872H84.624a5.872 5.872 0 01-5.872-5.872v-11.17a23.118 23.118 0 0123.12-23.12h14.782a23.117 23.117 0 0123.117 23.12z"
      fill="#1d1d1b"
    />
    <rect
      data-name="Rectangle 1506"
      width={85.827}
      height={9.403}
      rx={4.701}
      transform="translate(169.331 166.83)"
      fill="#c6c6c5"
    />
    <rect
      data-name="Rectangle 1507"
      width={85.827}
      height={9.403}
      rx={4.701}
      transform="translate(169.331 185.636)"
      fill="#c6c6c5"
    />
    <rect
      data-name="Rectangle 1508"
      width={39.613}
      height={9.403}
      rx={4.701}
      transform="translate(169.331 215.333)"
      fill="#c6c6c5"
    />
    <circle
      data-name="Ellipse 4693"
      cx={19.214}
      cy={19.214}
      r={19.214}
      transform="translate(90.047 139.776)"
      fill="#1d1d1b"
    />
    <path data-name="Path 40217" d="M67.523 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40218" d="M81.136 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <circle
      data-name="Ellipse 4694"
      cx={1.702}
      cy={1.702}
      r={1.702}
      transform="translate(93.046 269.375)"
      fill="#1d1d1b"
    />
    <path data-name="Path 40219" d="M108.361 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40220" d="M53.911 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40221" d="M67.523 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40222" d="M81.136 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40223" d="M94.748 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40224" d="M108.361 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <circle
      data-name="Ellipse 4695"
      cx={1.702}
      cy={1.702}
      r={1.702}
      transform="translate(120.271 269.375)"
      fill="#1d1d1b"
    />
    <path data-name="Path 40225" d="M135.586 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <circle
      data-name="Ellipse 4696"
      cx={1.702}
      cy={1.702}
      r={1.702}
      transform="translate(147.496 269.375)"
      fill="#1d1d1b"
    />
    <path data-name="Path 40226" d="M162.811 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40227" d="M176.423 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40228" d="M121.973 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40229" d="M135.586 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40230" d="M149.2 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40231" d="M162.811 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40232" d="M176.423 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40233" d="M190.036 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <circle
      data-name="Ellipse 4697"
      cx={1.702}
      cy={1.702}
      r={1.702}
      transform="translate(201.946 269.375)"
      fill="#1d1d1b"
    />
    <path data-name="Path 40234" d="M217.261 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40235" d="M230.873 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40236" d="M244.486 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40237" d="M190.036 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40238" d="M203.648 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40239" d="M217.261 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40240" d="M230.873 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40241" d="M244.486 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40242" d="M258.1 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40243" d="M271.71 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40244" d="M285.323 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40245" d="M298.935 269.375a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40246" d="M258.1 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40247" d="M271.71 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40248" d="M285.323 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40249" d="M298.935 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40250" d="M312.548 255.763a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40251" d="M298.935 242.15a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40252" d="M312.548 242.15a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40253" d="M298.935 228.538a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40254" d="M312.548 228.538a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40255" d="M298.935 214.925a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40256" d="M298.935 201.313a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40257" d="M312.548 214.925a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40258" d="M312.548 201.313a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40259" d="M298.935 187.7a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40260" d="M312.548 187.7a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40261" d="M298.935 174.088a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40262" d="M312.548 174.088a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40263" d="M298.935 160.475a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40264" d="M312.548 160.475a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40265" d="M298.935 146.863a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40266" d="M298.935 133.25a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40267" d="M312.548 146.863a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40268" d="M312.548 133.25a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40269" d="M298.935 119.638a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40270" d="M312.548 119.638a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40271" d="M298.935 106.025a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40272" d="M312.548 106.025a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40273" d="M298.935 92.413a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
  </svg>
)
export { IDFront }
